import { useMutationCommon } from "hooks/useCRUD";
import IssueInvoiceService from "services/IssueInvoiceService";

// Lấy dữ liệu mặc định cho biên bản thỏa thuận
export const useGetAgreementInfo = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.getAgreementInfo,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "getAgreementInfo",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Danh sách biên bản thỏa thuận đã lập của một hóa đơn
export const useGetAgreementList = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.getAgreementList,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "getAgreementList",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Xem trước số tiền biên bản trả hàng theo các dòng còn giữ lại.
// Gọi mỗi lần xóa / khôi phục một dòng; FE không tự tính tiền.
export const usePreviewAgreementGra = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.previewAgreementGra,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "previewAgreementGra",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Upload file biên bản đã ký giấy
export const useUploadAgreementFile = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.uploadAgreementFile,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "uploadAgreementFile",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Gắn file đã ký giấy vào biên bản thỏa thuận
export const useAttachAgreement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.attachAgreement,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "attachAgreement",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: true,
  });

  return mutation;
};

// Tải file PDF của biên bản thỏa thuận đã lưu
export const useDownloadAgreement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.downloadAgreement,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "downloadAgreement",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Lưu biên bản thỏa thuận. Không báo toast thành công ở đây: BE có thể trả
// HTTP 200 kèm result: false, nơi gọi kiểm tra result rồi mới báo.
export const useSaveAgreementInfo = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.saveAgreementInfo,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "saveAgreementInfo",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// ── Ký số biên bản thỏa thuận ───────────────────────────────────────────────

// Bên B ký số. Không báo toast thành công ở đây: đây mới là bước giữa của chuỗi
// ký, báo sớm sẽ khiến người dùng tưởng đã xong trong khi còn chờ mssigning.
export const useSignAgreement = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.signAgreement,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "signAgreement",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};

// Poll trạng thái ký. Tắt cả hai loại toast vì hàm này gọi lặp nhiều lần.
export const useGetAgreementSignInfo = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.getAgreementSignInfo,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "getAgreementSignInfo",
    target: "agreementReport",
    isNotifyError: false,
    isNotifySuccess: false,
  });

  return mutation;
};

// Tạo phiên ký trên cổng ký + gửi mail cho bên mua. Đây là bước CUỐI của chuỗi
// nên mới báo thành công.
export const useSendAgreementSignMail = ({
  onSuccess = undefined,
  onError = undefined,
}) => {
  const { mutation } = useMutationCommon({
    mutationFn: IssueInvoiceService.sendAgreementSignMail,
    onSuccess,
    onError,
    translation: ["issueInvoice"],
    translationAction: "sendAgreementSignMail",
    target: "agreementReport",
    isNotifyError: true,
    isNotifySuccess: false,
  });

  return mutation;
};
